<div class="app-user-view content">
    <header class="sticky-header">
        <div class="left-column">
            <div class="icon-header">
                <div class="icon-container">
                    <mat-spinner *ngIf="loadingUserDetails" matSuffix diameter="30" color="warn"></mat-spinner>
                    <mat-icon *ngIf="!loadingUserDetails">person</mat-icon>
                </div>
                <h1 data-automation="view-title">
                    <ng-container *ngIf="!loadingUserDetails">
                        {{ user.fullName }}
                    </ng-container>
                    <ng-container *ngIf="loadingUserDetails">
                        {{ 'user.loading_user' | translate }}
                    </ng-container>
                </h1>
                <p *ngIf="user" class="subtitle" data-automation="view-subtitle">
                    <span class="status-text" data-automation="status">{{ user.email }}</span>
                </p>
            </div>
        </div>

        <div class="right-column">
            <button class="icon-btn x-btn-primary" data-automation="userEdit" [disabled]="!enableEditBtn()"
                (click)="handleEdit()">
                <mat-icon>edit</mat-icon>
                <span class="btn-text">{{ 'user.button.edit' | translate }}</span>
            </button>
        </div>
    </header>

    <app-user-status-bar [status]="user.status" [userId]="userId" [selectedOrg]="orgId"></app-user-status-bar>

    <form #view="ngForm" class="user-form">
        <!--- VIEW --->
        <ng-container *ngIf="user">
            <div data-automation="userLoaded" *ngIf="!loadingUserDetails"></div>
            <div class="mrgn-top"></div>

            <div>
                <div class="form-group">
                    <!--- Enel Employee ID --->
                    <div class="form-entry" *ngIf="isInternal">
                        <mat-label class="info-title">{{ 'user.enel_employee_id' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="enel_employee_id">
                            {{ user && user.enel_employee_id ? user.enel_employee_id : '-' }}
                        </mat-label>
                    </div>
                    <!--- First name --->
                    <div class="form-entry">
                        <mat-label class="form-entry-column info-title">{{ 'user.first_name' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="first_name">
                            {{ user.first_names[user.locale] }}
                        </mat-label>
                    </div>

                    <!--- Last name --->
                    <div class="form-entry">
                        <mat-label class="form-entry-column info-title">{{ 'user.last_name' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="last_name">
                            {{ user.last_names[user.locale] }}
                        </mat-label>
                    </div>

                    <!--- Organization --->
                    <div class="form-entry">
                        <mat-label class="info-title">{{ 'user.organization' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="organization">
                            {{ user ? user.organization_name : '-' }}
                        </mat-label>
                    </div>

                    <!--- Username --->
                    <div class="form-entry">
                        <mat-label class="info-title">{{ 'user.user_name' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="username">
                            {{ user.username }}
                        </mat-label>
                    </div>

                    <!--- Title --->
                    <div class="form-entry">
                        <mat-label class="info-title">{{ 'user.title' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="business_role">
                            {{ user && user.title ? user.title : '-' }}
                        </mat-label>
                    </div>

                    <!--- User Type --->
                    <div class="form-entry" *ngIf="!isOnboarding">
                        <mat-label class="info-title">{{ 'user.user_type' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="brand">
                            {{ user.userType }}
                        </mat-label>
                    </div>

                    <!--- Locale --->
                    <div class="form-entry">
                        <mat-label class="info-title">{{ 'user.locale' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="locale">
                            {{ getLocaleForUser().displayLabel }}
                        </mat-label>
                    </div>

                    <!--- User Brand --->
                    <div class="form-entry" *ngIf="!isOnboarding">
                        <mat-label class="info-title">{{ 'user.brand' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="brand">
                            {{ user.brand ? getBrandForUser() : '-' }}
                        </mat-label>
                    </div>

                    <!--- User Class --->
                    <div class="form-entry" *ngIf="!isOnboarding && !isExternalOwnProfile">
                        <mat-label class="info-title">{{ 'user.system_user' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="system_user">
                            {{ (user.userClass === 'SYSTEM' ? 'user.true' : 'user.false') | translate }}
                        </mat-label>
                    </div>

                    <!--- Asset Manager --->
                    <div class="form-entry" *ngIf="!isOnboarding && user.userClass === 'SYSTEM'">
                        <mat-label class="info-title">{{ 'user.asset_manager' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="asset_manager">
                            {{ (user.asset_manager ? 'user.true' : 'user.false') | translate }}
                        </mat-label>
                    </div>

                    <!--- System User Password --->
                    <div class="full-form-entry" *ngIf="!isOnboarding && hasSystemPassword">
                        <mat-label class="info-title alignment-padding-top">{{ 'user.password' | translate }}:</mat-label>
                        <div class="api-key-row">
                            <mat-label class="api-token alignment-padding-top" data-automation="system_user_password">
                                {{ displayedPassword }}
                            </mat-label>
                            <button
                                mat-button
                                type="button"
                                class="show-key-button"
                                data-automation="reveal_password"
                                (click)="togglePasswordVisibility()"
                                [attr.aria-label]="(showFullPassword ? 'user.hide_password' : 'user.show_password') | translate"
                            >
                                <mat-icon aria-hidden="true">
                                    {{ showFullPassword ? 'visibility_off' : 'visibility' }}
                                </mat-icon>
                                <span>
                                    {{ (showFullPassword ? 'user.hide_password' : 'user.show_password') | translate }}
                                </span>
                            </button>
                            <button
                                mat-button
                                type="button"
                                class="show-key-button"
                                data-automation="copy_password"
                                (click)="copySystemPassword()"
                                [attr.aria-label]="'user.copy_password' | translate"
                            >
                                <mat-icon aria-hidden="true">content_copy</mat-icon>
                                <span>{{ 'user.copy_password' | translate }}</span>
                            </button>
                        </div>
                    </div>

                    <!--- Country--->
                    <div class="form-entry">
                        <mat-label class="info-title">{{ 'user.country' | translate }}:</mat-label>
                        <mat-label>{{ user?.addresses[0]?.country }}</mat-label>
                    </div>

                    <!--- User Flex Contact ID --->
                    <div class="form-entry" *ngIf="!isOnboarding && !isExternalOwnProfile">
                        <mat-label class="info-title">{{ 'user.contact_id' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="flex_contact_id">
                            {{ user.flex_contact_id || '-' }}
                        </mat-label>
                    </div>

                    <!--- Primary Org is Data Provider --->
                    <div class="form-entry data-provider-entry" *ngIf="!isOnboarding && !isExternalOwnProfile">
                        <mat-label class="info-title" data-automation="primaryOrgDataProviderLabel">{{ 'user.primary_org_data_provider' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="primaryOrgDataProviderValue">
                            {{ (!!user.organization_is_data_provider ? 'user.true' : 'user.false') | translate }}
                        </mat-label>
                    </div>
                </div>
                <div class="button-container">
                    <div class="right-button">
                        <button class="icon-btn x-btn-secondary squared" (click)="collapseAll()">
                            <mat-icon>expand_less</mat-icon>
                            <span class="btn-text">{{ 'user.collapse_all' | translate }}</span>
                        </button>
                    </div>
                    <div class="right-button">
                        <button class="icon-btn x-btn-secondary squared" (click)="expandAll()">
                            <mat-icon>expand_more</mat-icon>
                            <span class="btn-text">{{ 'user.expand_all' | translate }}</span>
                        </button>
                    </div>
                </div>
            </div>

            <mat-expansion-panel togglePosition="before" data-automation="contact_information_panel"
                [expanded]="collapseArray[0]" (opened)="expansionOpened(0)" (closed)="expansionClosed(0)">
                <mat-expansion-panel-header class="panel-override" collapsedHeight="54px" expandedHeight="54px"
                    data-automation="contact_information_header">
                    <mat-panel-title>
                        <h4 class="card-title" data-automation="contact_information">
                            {{ 'user.contact_information' | translate }}
                        </h4>
                    </mat-panel-title>
                    <mat-panel-description class="contact_information_subtitle"> </mat-panel-description>
                </mat-expansion-panel-header>

                <!--- User Preferences --->
                <!-- <h4 class="form-header">{{ 'user.preferences' | translate }}</h4> -->
                <div class="form-group">
                    <!--- Email --->
                    <div class="form-entry">
                        <mat-label class="info-title">{{ 'user.email' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="email">
                            {{ user.email }}
                        </mat-label>
                    </div>

                    <!--- Phone Number --->
                    <div class="form-entry">
                        <mat-label class="info-title">{{ 'user.phone_number' | translate }}:</mat-label>
                        <div class="form-entry-column" data-automation="phone_number">
                            <ng-container *ngIf="hasPhone()">
                                <mat-label *ngFor="let phone of user.phones">
                                    <ng-container *ngIf="phone.primary && phone.phone_type != 'MOBILE'">
                                        <span *ngIf="phone.country_code">+{{ phone.country_code }}</span>
                                        {{ phone.phone_number | phone_number }}
                                        <span *ngIf="phone.extension">(ext {{ phone.extension }})</span>
                                    </ng-container>
                                </mat-label>
                            </ng-container>
                            <ng-container *ngIf="!hasPhone()">
                                <mat-label>-</mat-label>
                            </ng-container>
                        </div>
                    </div>

                    <!--- Mobile Phone Number --->
                    <div class="form-entry">
                        <mat-label class="info-title">{{ 'user.mobile_phone_number' | translate }}:</mat-label>
                        <div class="form-entry-column" data-automation="mobile_phone_number">
                            <ng-container *ngIf="hasMobile()">
                                <mat-label>
                                    <span *ngIf="mobile.country_code">+{{ mobile.country_code }}</span>
                                    {{ mobile.phone_number | phone_number }}
                                    <span *ngIf="mobile.extension">(ext {{ mobile.extension }})</span>
                                </mat-label>
                            </ng-container>
                            <ng-container *ngIf="!hasMobile()">
                                <mat-label>-</mat-label>
                            </ng-container>
                        </div>
                    </div>

                    <!--- primary_contact --->
                    <div class="form-entry">
                        <mat-label class="info-title">{{ 'user.primary_contact' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="primary_contact">
                            {{ (!!user.primary_contact ? 'user.true' : 'user.false') | translate }}
                        </mat-label>
                    </div>

                    <!--- twentyfour_seven_contact --->
                    <div class="form-entry">
                        <mat-label class="info-title">{{ 'user.24_7_contact' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="twentyfour_seven_contact">
                            {{ (!!user.twentyfour_seven_contact ? 'user.true' : 'user.false') | translate }}
                        </mat-label>
                    </div>
                </div>

                <div class="form-group table-container">
                    <app-subscription-table mode="view" [userId]="userId" [hasOnboardingRole]="hasOnboardingRole"
                        [hasDRFinancialRole]="hasDRFinancialRole"></app-subscription-table>
                </div>
            </mat-expansion-panel>

            <ng-container *ngIf="showRoles && !isExternalOwnProfile">
                <mat-expansion-panel togglePosition="before" data-automation="user_roles_panel"
                    [expanded]="collapseArray[1]" (opened)="expansionOpened(1)" (closed)="expansionClosed(1)">
                    <mat-expansion-panel-header class="panel-override" collapsedHeight="54px" expandedHeight="54px"
                        data-automation="user_roles_header">
                        <mat-panel-title>
                            <h4 class="card-title" data-automation="user_roles">{{ 'user.user_roles' | translate }}</h4>
                        </mat-panel-title>
                        <mat-panel-description class="user_roles_subtitle"> </mat-panel-description>
                    </mat-expansion-panel-header>

                    <div class="form-group">
                        <app-active-location-roles></app-active-location-roles>
                    </div>
                </mat-expansion-panel>
            </ng-container>

            <mat-expansion-panel togglePosition="before" data-automation="syncInfoSectionView"
                [expanded]="collapseArray[2]" (opened)="expansionOpened(2)" (closed)="expansionClosed(2)"
                *ngIf="showSyncSection">
                <mat-expansion-panel-header class="panel-override" collapsedHeight="54px" expandedHeight="54px"
                    data-automation="sync_information_header">
                    <mat-panel-title>
                        <h4 class="card-title" data-automation="sync_information">
                            {{ 'user.sync_information' | translate }}
                        </h4>
                    </mat-panel-title>
                    <mat-panel-description class="sync_information_subtitle"> </mat-panel-description>
                </mat-expansion-panel-header>

                <div class="form-group">
                    <!-- ECRM Contact ID -->
                    <div class="form-entry">
                        <mat-label class="info-title">{{ 'user.ecrm_contact_id' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="ecrm_contact_id">
                            {{ user.contact_id ? user.contact_id : '-' }}
                        </mat-label>
                    </div>

                    <!-- ECRM ID -->
                    <div class="form-entry">
                        <mat-label class="info-title">{{ 'user.ecrm_id' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="ecrm_id">
                            {{ user.ecrm_id ? user.ecrm_id : '-' }}
                        </mat-label>
                    </div>

                    <!--- Last sync date --->
                    <div *ngIf="user.sync_to_ecrm" class="form-entry">
                        <mat-label data-automation="last_sync_label" class="form-entry-column info-title">{{
                            'user.last_sync_date' | translate }}:</mat-label>
                        <mat-label *ngIf="user.last_sync_date" class="info-value" data-automation="last_sync_date">
                            {{ user.last_sync_date | date : 'medium' }}
                        </mat-label>
                        <mat-label *ngIf="!user.last_sync_date" class="info-value" data-automation="last_sync_date">
                            {{ 'user.no_sync_to_ecrm' | translate }}
                        </mat-label>
                    </div>

                    <!--- Sync to ECRM --->
                    <div class="form-entry" data-automation="sync_to_ecrm_label">
                        <mat-label class="info-title">{{ 'user.sync_to_ecrm' | translate }}:</mat-label>
                        <mat-label class="info-value">
                            {{ user.sync_to_ecrm ? ('user.true' | translate) : '-' }}
                        </mat-label>
                    </div>
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel togglePosition="before" data-automation="user_settings_panel"
                [expanded]="collapseArray[3]" (opened)="expansionOpened(3)" (closed)="expansionClosed(3)">
                <mat-expansion-panel-header class="panel-override" collapsedHeight="54px" expandedHeight="54px"
                    data-automation="user_settings_header">
                    <mat-panel-title>
                        <h4 class="card-title" data-automation="user_settings">
                            {{ 'user.user_settings' | translate }}
                        </h4>
                    </mat-panel-title>
                    <mat-panel-description class="user_settings_subtitle"> </mat-panel-description>
                </mat-expansion-panel-header>

                <div class="form-group">
                    <!--- Timezone --->
                    <div class="form-entry">
                        <mat-label class="info-title">{{ 'user.timezone' | translate }}:</mat-label>
                        <mat-label class="info-value ellipsis" data-automation="timezone">
                            {{ getTimezoneForUser().displayLabel }}
                        </mat-label>
                    </div>

                    <!--- Measurement System --->
                    <div class="form-entry">
                        <mat-label class="info-title">{{ 'user.measurement' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="measurement_system">
                            {{ getLocalizedUnitSystem() }}
                        </mat-label>
                    </div>

                    <!--- Home Application --->
                    <div class="form-entry">
                        <mat-label class="info-title">{{ 'user.home_application' | translate }}:</mat-label>
                        <mat-label class="info-value" data-automation="home_application">
                            {{ user.home_application ? getHomeApplicationForUser() : '-' }}
                        </mat-label>
                    </div>
                </div>
            </mat-expansion-panel>

            <mat-expansion-panel togglePosition="before" data-automation="user_api_keys_panel"
                [expanded]="collapseArray[4]" (opened)="expansionOpened(4)" (closed)="expansionClosed(4)"
                *ngIf="user.userClass === 'SYSTEM' && apiKey?.keyId">
                <mat-expansion-panel-header class="panel-override" collapsedHeight="54px" expandedHeight="54px"
                    data-automation="user_api_keys_header">
                    <mat-panel-title>
                        <h4 class="card-title" data-automation="user_api_keys">
                            {{ 'user.api_keys' | translate }}
                        </h4>
                    </mat-panel-title>
                    <mat-panel-description class="user_api_keys_subtitle"> </mat-panel-description>
                </mat-expansion-panel-header>

                <div class="form-group">
                    <!--- API Keys --->
                    <div class="full-form-entry">
                        <mat-label class="info-title alignment-padding-top">
                            {{ apiKey?.displayLabel || 'API Key' }}:
                        </mat-label>

                        <div class="api-key-row">
                            <mat-label class="api-token alignment-padding-top" data-automation="system_user_api_key">
                                {{ displayedToken }}
                            </mat-label>

                            <button mat-button type="button" class="show-key-button" (click)="toggleKeyVisibility()"
                                [disabled]="!apiKey?.token" aria-label="Toggle API key visibility">
                                <mat-icon aria-hidden="true">
                                    {{ showFullKey ? 'visibility_off' : 'visibility' }}
                                </mat-icon>
                                <span>
                                    {{ showFullKey ? 'Hide key' : 'Show key' }}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </mat-expansion-panel>
        </ng-container>
    </form>
</div>
